import * as React from 'react';
import {findCondition, finishDeclaration} from '../../../../services/verisk/reducer';
import ConditionSearch from './scenes/ConditionSearch/index';
import ConditionQuestions from './scenes/ConditionQuestions/index';
import DeclaredConditions from './scenes/DeclaredConditions/index';
import { Button } from 'react-bootstrap';
import { getIncludedResource } from '../../../../data/api/util';
import { FaUserAlt } from 'react-icons/fa';

export default class VeriskSession extends React.Component<any, any> {
  // static propTypes = {
  //   index: PropTypes.number.isRequired,
  //   screening: PropTypes.object.isRequired,
  //   dispatch: PropTypes.func.isRequired,
  //   finishScreening: PropTypes.func.isRequired,
  // };

  public state = {
    isAboutToScreen: '',
  };

  private finishDeclaration = () => {
    const { dispatch, setHasScreenedCondition } = this.props;
    this.setState({ isAboutToScreen: '' });
    setHasScreenedCondition(false);
    dispatch(finishDeclaration());
  }

  private conditionChange = (condition) => {
    this.setState({ isAboutToScreen: condition });
  }

  private handleFinishScreeningClick = () => {
    const { setHasScreenedCondition, finishScreening } = this.props;
    setHasScreenedCondition(false);
    finishScreening();
  };

  public render() {
    const { index, screening, dispatch, travellerName, travellerDob, isControlGroup } = this.props;
    const { isAboutToScreen } = this.state;
    const conditions = getIncludedResource(
      screening.declaration.data,
      screening.declaration.included,
      'conditions',
      true,
    );

    return (

      <div className={isControlGroup ? 'screening-session-healix control-group' : 'screening-session-healix'}>
        <div className="traveller-name">
          {isControlGroup && <FaUserAlt className="traveller-icon" />}

          <div className="traveller-text">
            <strong>{travellerName}</strong>

            {isControlGroup && (
              <span className="med-cond-dob">
                ({travellerDob})
              </span>
            )}
          </div>
        </div>

        <div className="screening-body">
          {screening.declaredConditions?.data && (
            <div className="row dynamic-row">
              <div className="col-xs-12">
                <DeclaredConditions
                  dispatch={dispatch}
                  screening={screening}
                  isControlGroup={isControlGroup}
                />
              </div>
            </div>
          )}
          {conditions.length ? conditions.map((condition, i) => {
            return (
              <ConditionQuestions
                key={i}
                condition={condition}
                dispatch={dispatch}
                screening={screening}/>
            );
          }) : (
            <ConditionSearch
              index={index}
              dispatch={dispatch}
              conditionProps={this.state.isAboutToScreen}
              conditionChange={this.conditionChange}
              screening={screening}
              isControlGroup={isControlGroup}
              setHasScreenedCondition={this.props.setHasScreenedCondition}
            />
          )}

          {!screening.complete
            && screening.declaration.data.attributes.state === 'ready' && (
              <div className="row declaration-actions dynamic-row">
                <div className="col-xs-12">
                  <Button
                    bsStyle="primary"
                    id="continue"
                    disabled={screening.isSubmitting}
                    className="pull-right"
                    onClick={this.finishDeclaration}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            )}
          {screening.complete && !isAboutToScreen && screening.declaredConditions?.data && (
            <div className="row declaration-actions dynamic-row">
              <div className="col-xs-12">
                <Button
                  className="pull-right"
                  bsStyle="primary"
                  disabled={(screening.isSubmitting && screening.index === index)}
                  onClick={this.handleFinishScreeningClick}
                >
                  Finish Screening
                </Button>
              </div>
            </div>
          )}
          {isControlGroup && !screening.declaredConditions?.data && !screening.declaration?.data?.attributes?.state && (
            <div className="row declaration-actions dynamic-row">
              <div className="col-xs-12">
                <Button
                  bsStyle="default"
                  id="cancel"
                  className="pull-left"
                  onClick={this.handleFinishScreeningClick}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
